/* eslint-disable max-len */
module.exports = {
  map: {
    primaryTileLayerUrl: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    primaryTileLayerAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    secondaryTileLayerUrl: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    secondaryTileLayerAttribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    enableAttribution: true,
    defaultZoomLevel: 3,
    maxZoomLevel: 16,
    minZoomLevel: 2,
    maxBoundsWorld: [ [ -90, -180 ], [ 90, 180 ] ],
    repositionedZoomLevel: 10,
    defaultCenter: [ 40, -90 ],
    maxClusterDistanceInKm: 0.875, // 2.75,
  },
  geolocation: { // https://developer.mozilla.org/en-US/docs/Web/API/PositionOptions
    enableHighAccuracy: true,
    timeout: 7500,
  },
  geosearch: { // https://github.com/smeijer/leaflet-geosearch#geosearchcontrol
    showMarker: false,
    showPopup: false,
    animateZoom: false,
    autoClose: false,
    keepResult: false,
    updateMap: true,
    popupFormat: ({ result }) => `${result.label}`,
    resultFormat: ({ result }) => `${result.label}`,
    autoComplete: true,
    autoCompleteDelay: 250,
    zoomLevel: 5,
    notFoundMessage: 'No results found close to this location',
    searchLabel: 'Search location',
    style: 'bar',
  },
  maxImageUploadSize: 15000000, // in bytes
};
